import React, { useState, Fragment, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  TextField,
  Divider,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import Alert from "widgets/alert";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import { clientPay } from "configurations/axios";
import {
  API_GET_ALL_COMPANY ,
  API_POST_SAVE_ADD_VOUCHER,
} from "../apis";
const useStyles = makeStyles((theme) => ({
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  textFieldComboBox: {
    minWidth: "100%",
    maxWidth: "100%",
  },
}));

const AsignarComprobantes = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const userToken = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErros] = useState({});
  const [packet, setPacket] = useState({});

  const handleClickOpen = () => {
    setOpen(true);
    setErros({});
    setSelectedCompany({});
  };

  const handleClose = () => {
    setOpen(false);
    setMsg({ show: false, msg: null, type: null });
    setCompany([]);
  };
  function closeAlert() {
    setMsg({ show: false });
  }

  const getCompanies = async (token) => {
    if (open) {
      await clientPay
        .get(API_GET_ALL_COMPANY  + (token ? getRUCEmpresa(token) : "0"))
        .then((result) => {
          if (result.status === 200) {
            let companies = result.data.content;
            for (let i = 0; i < companies.length; i++) {
              companies[i].label =
                companies[i].razonSocialempresa +
                " / " +
                companies[i].idempresacontratante;
            }
            setCompany(companies);
          }
        })
        .catch((exception) => {
          setCompany([{ label: "Error al cargar las empresas" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las empresas.",
          });
        });
    }
  };

  const renderCompanies = () => {
    if (company.length === 0 && userToken) {
      getCompanies(userToken);
    }
    return (
      <Autocomplete
        value={selectedCompany}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
          setPacket({
            ...packet, 
            rucEmpresa: newValue.idempresacontratante, 
            rucPartner: newValue.empresaContadora.idempresacontadora});
        }}
        options={company}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={company.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de empresas"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {company.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const handleChange = (event) =>{
    setPacket({
      ...packet,
      [event.target.name]: event.target.value
    });
  }

  const handleAddVouchers = async (event) => {
    let validations = {};
    setOpenLoader(true);
    event.preventDefault();
    if (selectedCompany) {
      if (
        selectedCompany.idempresacontratante === null ||
        typeof selectedCompany.idempresacontratante === "undefined"
      ) {
        validations.selectedCompany = "Seleccione una empresa.";
      }
    } else {
      validations.selectedCompany = "Seleccione una empresa.";
    }
    if (
      packet.numeroComprobantes === null ||
      typeof packet.numeroComprobantes === "undefined"
    ) {
      validations.numeroComprobantes = "Ingrese un número de comprobantes.";
    }
    if (Object.keys(validations).length === 0) {
      await clientPay
        .post(
          API_POST_SAVE_ADD_VOUCHER, packet 
        )
        .then((response) => {
          enqueueSnackbar("Comprobantes asignados.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 10000,
          });
          updateView();
          handleClose();
          setOpenLoader(false);
        })
        .catch((exception) => {
          if (exception.response) {
            if (exception.response.status === 400) {
              setMsg({
                show: true,
                msg: "No se pudo asignar los comprobantes a la empresa.",
              });
            } else if (exception.response.status === 404) {
              setMsg({
                show: true,
                msg: "No se encontró la empresa para asignar.",
              });
            } else {
              setMsg({
                show: true,
                msg:
                  "Error al asignar comprobantes a la empresa. Contáctese con el administrador del Sistema.",
              });
            }
          } else {
            setMsg({
              show: true,
              msg:
                "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            });
          }
          setOpenLoader(false);
        });
    } else {
      setErros(validations);
      setOpenLoader(false);
    }
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <AddCircleIcon
          style={{ color: palette.primary.contrastText, paddingRight: '3%' }}
          fontSize="small"
        />{"  "}
        Asignar comprobantes
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Asignar comprobantes a empresas afiliadas al partner{" "}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddVouchers}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              <Grid item xs={12} md={4}>
                Empresa: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                {renderCompanies()}
                {errors.selectedCompany ? (
                  <p className={classesApp.errorLetters}>
                    {errors.selectedCompany}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Número de comprobantes a agregar: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="number"
                value={packet.numeroComprobantes}
                onChange={handleChange}
                name="numeroComprobantes"
                className={
                  errors.numeroComprobantes
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.numeroComprobantes ? (
                  <p className={classesApp.errorLetters}>
                    {errors.numeroComprobantes}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Precio de comprobantes: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="number"
                value={packet.precioComprobantes}
                onChange={handleChange}
                name="precioComprobantes"
                className={
                  errors.precioComprobantes
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.precioComprobantes ? (
                  <p className={classesApp.errorLetters}>
                    {errors.precioComprobantes}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Fecha fin de contratación: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="date"
                value={packet.fechaFinContratacion}
                onChange={handleChange}
                name="fechaFinContratacion"
                className={
                  errors.fechaFinContratacion
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.fechaFinContratacion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.fechaFinContratacion}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Observación: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="text"
                value={packet.observacion}
                onChange={handleChange}
                name="observacion"
                className={
                  errors.observacion
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.observacion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.observacion}
                  </p>
                ) : null}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AsignarComprobantes;
